module.exports = __webpack_public_path__ + "docs/assets/fonts/Raleway-Regular-20d41940068e45b114d32b48d684ef39.ttf";